import { render, staticRenderFns } from "./ReportProjectField.vue?vue&type=template&id=533dafaa&"
import script from "./ReportProjectField.vue?vue&type=script&lang=js&"
export * from "./ReportProjectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QIcon,QItem,QItemSection,QItemLabel}, component.options.components || {})
